export default __webpack_public_path__ + "static/media/popup-cancel.23f88d3a.svg";